<template>
  <div>
    <div class="page-wrapper" :class="layout_settings_sidebar_type">
      <!--<Header @clicked="sidebar_toggle" @mobileclicked="mobiletoggle_toggle" /> --> <!-- @rightclicked="rightsidebar_toggle" -->
      <div class="page-body-wrapper" :class="layout_settings_sidebar_body_type">
        <div class="page-sidebar" :class="[{ open : sidebar_toggle_var }, layout.settings.sidebar_backround]" :sidebar-layout="layout.settings.sidebar_setting">
          <Sidebar @clicked="sidebar_toggle" v-on-clickaway="clickOutSidebar"/>
        </div>
        <!--<RightSidebar :rightsidebar_toggle_var = rightsidebar_toggle_var />-->
        <div class="page-body body-991" style="padding: 0px;">
          <!--<vue-progress-bar></vue-progress-bar>-->
          <!--<transition name="fadeIn" enter-active-class="animated fadeIn">
           <router-view class="view"></router-view>
          </transition>-->
          <router-view @clicked="sidebar_toggle" class="view"></router-view>
        </div>
        <!--<Footer/>-->
      </div>
      <!--<Customizer/>-->
      <Filters/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from './header'
import Sidebar from './sidebar'
//import RightSidebar from './right_sidebar'
//import Footer from './footer'
//import Customizer from './customizer'
import Filters from './filters'
import {mixin as clickOutSidebar} from 'vue-clickaway'

export default {
  name: 'mainpage',
  mixins: [clickOutSidebar],
  data(){
    return{
      //rightsidebar_toggle_var: false,
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      resized: false,
      layout_settings_sidebar_type: "default",
      layout_settings_sidebar_body_type: "border-sidebar"
    }
  },
  // props:['sidebar_toggle_var'],
  components:{
    Header,
    Sidebar,
    //RightSidebar,
    //Footer,
    //Customizer,
    Filters
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout
    })
  },
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.resized = this.sidebar_toggle_var;
    this.$store.dispatch('layout/set')
  },
  watch:{
    '$route' (){
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', items)
        if (!items.children) return false
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subItems)
          if (!subItems.children) return false
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subSubItems)
          })
        })
      })
    },
    sidebar_toggle_var: function (){
      if (this.layout_settings_sidebar_type == "default") {
        this.layout_settings_sidebar_type = "compact-page";
        this.layout_settings_sidebar_body_type = "sidebar-hover";
      } else {
        this.layout_settings_sidebar_type = "default";
        this.layout_settings_sidebar_body_type = "default";
      }
  
    }
  },
  methods:{
    sidebar_toggle(value) {
      
      if (this.width <= 991 && this.sidebar_toggle_var == false) {
        //this.layout_settings_sidebar_type = "compact-page";
        //this.layout_settings_sidebar_body_type = "sidebar-hover";
        this.sidebar_toggle_var = true

      } else if (this.width <= 991 && this.sidebar_toggle_var == true) {

        //this.layout_settings_sidebar_type = "compact-page";
        //this.layout_settings_sidebar_body_type = "sidebar-hover";
        this.sidebar_toggle_var = false

      } else if (this.width > 991) {

        /*this.sidebar_toggle_var = false

        if (this.layout_settings_sidebar_type == "default") {

          console.log("3")

          this.layout_settings_sidebar_type = "compact-page";
          this.layout_settings_sidebar_body_type = "sidebar-hover";
        } else {

          console.log("4")

          this.layout_settings_sidebar_type = "default";
          this.layout_settings_sidebar_body_type = "default";
        }*/

      }

    },
    /*rightsidebar_toggle(value) {
      this.rightsidebar_toggle_var = value
    },*/
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value
    },
    handleResize() {

      this.width = window.innerWidth;
      this.height = window.innerHeight;

      /* Importante para calcular el alto de la pantalla, variable se aplica a los css */
      let vh = this.height * 0.01;  // NO borrar!
      document.documentElement.style.setProperty('--vh', `${vh}px`);  // NO borrar!

      if (this.width <= 991 && this.sidebar_toggle_var == false) {
        this.sidebar_toggle_var = true
      } 
      if (this.width > 991 && this.sidebar_toggle_var == true) {
        this.sidebar_toggle_var = false
      } 
    },
    clickOutSidebar (origen) {

      if (origen.clientY > 50 && this.width <= 991 && this.sidebar_toggle_var == false) {

        this.sidebar_toggle_var = true

      }
    },
  }
}
</script>

<style lang="scss">


</style>
